import React, { ReactElement } from "react"
import AcIcon from "~/components/atoms/AcIcon"
import ToggleButton from "~/components/twilio/ToggleButton"
import useDevices from "~/composable/twilio/useDevices"
import { usePermissionState } from "~/composable/twilio/usePermissionState"
import { PERMISSION_STATE } from "~/constants/twilio"

interface ToggleAudioButtonProps {
  toggleAudio: () => void
  isAudioEnabled: boolean
  disabled?: boolean
  className?: string
  children?: ReactElement | ReactElement[]
}

export default function ToggleAudioButton({
  toggleAudio,
  isAudioEnabled,
  disabled,
  className,
}: ToggleAudioButtonProps) {
  const { hasAudioInputDevices } = useDevices()
  const audioPermission = usePermissionState("microphone" as PermissionName)

  return (
    <ToggleButton
      className={`${className || ""} ${isAudioEnabled ? "on" : "off"}`}
      onClick={toggleAudio}
      disabled={!hasAudioInputDevices || audioPermission === PERMISSION_STATE.DENIED || disabled}
    >
      {isAudioEnabled ? <AcIcon name={"microphone"} /> : <AcIcon name={"microphone-slash"} />}
      <p className="desc">
        {!hasAudioInputDevices || audioPermission === PERMISSION_STATE.DENIED
          ? "ミュート解除"
          : isAudioEnabled
          ? "ミュート"
          : "ミュート解除"}
      </p>
    </ToggleButton>
  )
}
